import { has } from "lodash";
import AuthorQaSettingNewsfeedItem from "./author/author_qa_setting_newsfeed_item";
import BlogNewsfeedItem from "./editorial/blog_newsfeed_item";
import InterviewNewsfeedItem from "./editorial/interview_newsfeed_item";
import CommunityQuestionNewsfeedItem from "./community_question/community_question_newsfeed_item";
import CommunityAnswerNewsfeedItem from "./community_answer/community_answer_newsfeed_item";
import ReadStatusNewsfeedItem from "./read_status/read_status_newsfeed_item";
import UserStatusNewsfeedItem from "./user_status/user_status_newsfeed_item";
import RecommendationNewsfeedItem from "./recommendation/recommendation_newsfeed_item";
import ReviewNewsfeedItem from "./review/review_newsfeed_item";
import FriendNewsfeedItem from "./friend/friend_newsfeed_item";
import GiveawayRequestNewsfeedItem from "./giveaway/giveaway_request_newsfeed_item";
import GeneralStatusNewsfeedItem from "./general_status/general_status_newsfeed_item";
import GroupJoinNewsfeedItem from "./group_join/group_join_newsfeed_item";
import GroupDiscussionNewsfeedItem from "./group_discussion/group_discussion_newsfeed_item";
import RatingNewsfeedItem from "./rating/rating_newsfeed_item";
import CommentNewsfeedItem from "./comment/comment_newsfeed_item";
import AuthorBlogPostNewsfeedItem from "./author/author_blog_post_newsfeed_item";
import AuthorFollowNewsfeedItem from "./author/author_follow_newsfeed_item";
import ChallengeNewsfeedItem from "./challenge/challenge_newsfeed_item";
import UserQuoteNewsfeedItem from "./user_quote/user_quote_newsfeed_item";
import PollVoteNewsfeedItem from "./poll/poll_vote_newsfeed_item";
import TrendingGenreNewsfeedItem from "./book_inspiration/trending_genre_newsfeed_item";
import UserFollowingNewsfeedItem from "./user_following/user_following_newsfeed_item";
import NativeAd from "../ads/native_ads/native_ad";
import RecommendationRequestNewsfeedItem from "./recommendation_request/recommendation_request_newsfeed_item";
import ReadingNotesCollectionNewsfeedItem from "./reading_notes/reading_notes_collection_newsfeed_item";
import ReadingYearNewsfeedItem from "./reading_year/reading_year_newsfeed_item";
import ReadingNoteNewsfeedItem from "./reading_notes/reading_note_newsfeed_item";
import SharingNewsfeedItem from "./sharing/sharing_newsfeed_item";
import CustomNewsfeedItem from "./editorial/custom_newsfeed_item";

export const resourceTypeToComponentMap = {
  Blog: BlogNewsfeedItem,
  Interview: InterviewNewsfeedItem,
  CommunityQuestion: CommunityQuestionNewsfeedItem,
  CommunityAnswer: CommunityAnswerNewsfeedItem,
  ReadStatus: ReadStatusNewsfeedItem,
  UserStatus: UserStatusNewsfeedItem,
  GeneralStatus: GeneralStatusNewsfeedItem,
  Recommendation: RecommendationNewsfeedItem,
  Review: ReviewNewsfeedItem,
  Friend: FriendNewsfeedItem,
  GiveawayRequest: GiveawayRequestNewsfeedItem,
  GroupUser: GroupJoinNewsfeedItem,
  Rating: RatingNewsfeedItem,
  LikeOnExternalResourcePlaceholder: RatingNewsfeedItem,
  Comment: CommentNewsfeedItem,
  Topic: GroupDiscussionNewsfeedItem,
  AuthorBlogPost: AuthorBlogPostNewsfeedItem,
  AuthorFollowing: AuthorFollowNewsfeedItem,
  AuthorQaSetting: AuthorQaSettingNewsfeedItem,
  UserChallenge: ChallengeNewsfeedItem,
  UserQuote: UserQuoteNewsfeedItem,
  PollVote: PollVoteNewsfeedItem,
  TopList: TrendingGenreNewsfeedItem,
  UserFollowing: UserFollowingNewsfeedItem,
  NewsfeedAd: NativeAd,
  ReadingNotesCollectionPlaceholder: ReadingNotesCollectionNewsfeedItem,
  RecommendationRequest: RecommendationRequestNewsfeedItem,
  ReadingYear: ReadingYearNewsfeedItem,
  "Services::Models::ReadingNote": ReadingNoteNewsfeedItem,
  Sharing: SharingNewsfeedItem,
  CustomNewsfeedStory: CustomNewsfeedItem,
};

export function getNewsfeedItemByType(update) {
  if (update.resourceType === "Comment" && update.subjectType === "Topic") {
    return resourceTypeToComponentMap[update.subjectType];
  } else {
    return resourceTypeToComponentMap[update.resourceType];
  }
}

export function isNewsfeedTypeSupported(newsfeedType) {
  return has(resourceTypeToComponentMap, newsfeedType);
}

export function renderNewsfeedItem(update, props = {}) {
  const NewsfeedItem = this.getNewsfeedItemByType(update);
  if(NewsfeedItem){
    return <NewsfeedItem {...update} {...props}/>;
  } else {
    return null;
  }
}
